<!--  -->
<template>
  <div :class="isMobile?'mlayout':'layout'">
    <Aside></Aside>
    <div class="minner" v-if="isMobile" ref="scrollContainer">
      <div class="mcontainer">
        <div class="title">
          文物赏析
        </div>
        <div class="top-search">
          <div class="keysearch">
            <input type="text" v-model="keyword" name="keyword" placeholder="输入关键字搜索">
            <button @click="searchBykeword"></button>
            <span><img src="@/assets/images/mobile/home.png" alt=""></span>
          </div>
          <div class="navs">
            <swiper class="swiper-container" :options="swiperOption">
              <swiper-slide class="antiqueSlide">
                <ul>
                  <li @click="classify('all')">全部文物</li>
                  <!-- <li>
                    <span @click="showqw = !showqw">器物</span>
                    <div class="pulldown" v-if="showqw">
                      <span v-for="(item,i) in categories1" :key="i" @click="classify(item,'natrue')">{{item}}</span>
                    </div>
                  </li> -->
                  <li v-for="(item,i) in categories2" :key="i" @click="classify(item)">{{item}}</li>
                </ul>
              </swiper-slide>
            </swiper>

          </div>
        </div>
        <div class="list">
          <!-- <div class="item" v-for="(item,i) in mobileData" :key="i"
            @click="$router.push({path:'/detail/',query:{data:JSON.stringify(item)}})">
            <div v-if="item.link" class="imgC"><img :src="`${$url}/${item.id}.jpg`" alt=""></div>
            <div v-else class="imgC"><img :src="`${$url}/${item.id}/1.JPG`" alt=""></div>
            <div class="text"><span>{{item.name}}</span></div>
            <span class="d3" v-if="item.link"><img src="@/assets/images/mobile/3D.png" alt=""></span>

          </div> -->
          <div class="item" v-for="(item,i) in mobileData" :key="i"
            @click="$router.push({path:'/detail/',query:{data:item.id}})">
            <div v-if="item.link" class="imgC"><img :src="`${$url}/${item.id}.jpg`" alt=""></div>
            <div v-else class="imgC"><img :src="`${$url}/${item.id}/1.JPG`" alt=""></div>
            <div class="text"><span>{{item.name}}</span></div>
            <span class="d3" v-if="item.link"><img src="@/assets/images/mobile/3D.png" alt=""></span>

          </div>
        </div>
        <div class="nomore" v-if="nomore">
          <p>已经没有更多了！</p>
        </div>
        <div class="nothing" v-if="total==0">暂无相关文物！</div>
      </div>
      <div class="up-top" @click="backTop"><img src="@/assets/images/mobile/up.png" alt=""></div>
    </div>
    <div class='antiques' v-else>

      <bar v-if="!isMobile"></bar>
      <div class="inner">
        <div class="left-nav">
          <div class="search">
            <input type="text" name="keyword" v-model="keyword" placeholder="输入关键字搜索">
            <button @click="searchBykeword">搜索</button>
          </div>
          <div class="navs">
            <!-- <div class="nav nav1">
              <span @click="showqw = !showqw">器物</span>
              <ul v-if="showqw==true">
                <li v-for="(item,i) in categories1" :key="i" @click="classify(item,'nature')">{{item}}</li>
              </ul>
            </div> -->
            <div class="nav nav2">
              <span :class="'icon'+i" v-for="(item,i) in categories2" :key="i"
                @click="classify(item)">{{item}}</span>
            </div>
          </div>
        </div>
        <div class="list-container">
          <div class="list">
            <!-- <div class="item" v-for="(item,i) in curData" :key="i"
              @click="$router.push({path:'/detail/',query:{data:JSON.stringify(item)}})">
              <div v-if="item.link" class="imgC"><img :src="`${$url}/${item.id}.jpg`" alt=""></div>
              <div v-else class="imgC"><img :src="`${$url}/${item.id}/1.JPG`" alt=""></div>
              <div class="text"><span>{{item.name}}</span></div>
              <span class="d3" v-if="item.link"><img src="@/assets/images/mobile/3D.png" alt=""></span>
            </div> -->
            <div class="item" v-for="(item,i) in curData" :key="i"
              @click="$router.push({path:'/detail/',query:{data:item.id}})">
              <div v-if="item.link" class="imgC"><img :src="`${$url}/${item.id}.jpg`" alt=""></div>
              <div v-else class="imgC"><img :src="`${$url}/${item.id}/1.JPG`" alt=""></div>
              <div class="text"><span>{{item.name}}</span></div>
              <span class="d3" v-if="item.link"><img src="@/assets/images/mobile/3D.png" alt=""></span>
            </div>
            <div class="nothing" v-if="total==0">暂无相关文物！</div>
          </div>
          <div class="pages" v-show="pageshow">
            <paging @clickHandle="pageChange" :current="curpage" :total="total" :equable="pageSize"></paging>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  //这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  //例如：import 《组件名称》 from '《组件路径》';
  import 'swiper/dist/css/swiper.css' ////这里注意具体看使用的版本是否需要引入样式，以及具体位置。
  import {
    Swiper,
    SwiperSlide
  } from 'vue-awesome-swiper'

  import browser from '@/utils/browser.js'
  import aside from '@/components/layout/aside.vue'
  import bar from '@/components/layout/bar.vue'
  import paging from '@/components/paging.vue'
  export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
      Swiper,
      SwiperSlide,
      'Aside': aside,
      bar,
      paging
    },
    data() {
      //这里存放数据
      return {
        keyword: '',
        swiperOption: {
          direction: 'horizontal',
          slidesPerView: 'auto',
          freeMode: true,
        },
        isMobile: browser.mobile,
        showqw: false,
        active: '',
        categories2: ['器物类','名人遗物', '玺印符牌', '钱币', '文具', '题词手稿', '雕塑', '服装标识', '文件与宣传品', '档案文书', '票据', '邮品', '画像照片', '其他'],
        curclassify: '', //当前分类
        pageSize: 8,
        total: 1,
        curpage: 1, //当前页
        allData: [], //全部数据
        tempData: [], //当前分类或搜索内容总数据
        curData: [], //当前页数据
        mobileData: [],
        nomore: false,
        pageshow: false,
        tag: false //获取数据是否成功

      };
    },
    
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
      $route(route) {
        var query = route.query;
        console.log(query)
        this.tempData = this.allData.filter((item, i) => {
          if (query.keyword) {
            return item.name.indexOf(query.keyword) > -1
          } else if (query.type||query.nature){
            return (item.type == query.type) || (item.nature == query.nature)
          }else return true

        });
        this.mobileData = this.tempData.slice((this.curpage - 1) * 8, this.curpage * 8)

        this.total = this.tempData.length;
        this.curpage = query.page|| 1;
        console.log(this.curpage)
        console.log(this.total)
      },
      total(nval) {

        if (nval > 0) {

          this.pageshow = true;
        } else {
          this.pageshow = false;

        }

      },
      curpage() {
        if (this.isMobile) {
          this.loadingData();
        } else {
          this.getCurData(this.tempData)
        }

      },
      tag(val) {
        if (val) {
          if (this.isMobile) {
            this.loadingData();
          } else {
            this.getCurData(this.tempData);
          }

        }
      }
    },
 
    //方法集合
    methods: {
      //获取数据
      async getData() {
        let res = await this.$https({
          method: 'get',
          url: '/static/data.json',
        })

        this.allData = res.list;
        console.log(this.$route.query)
        this.tempData = this.allData.filter((item,i)=> {
            if(this.$route.query.keyword){
                return item.name.indexOf(this.$route.query.keyword) > -1
            }else if(this.$route.query.type||this.$route.query.nature) {
                return item.type==this.$route.query.type||item.nature==this.$route.query.nature
            }else return true
        });
        console.log(this.tempData)
        this.mobileData = this.tempData.slice((this.curpage - 1) * 8, this.curpage * 8);
        console.log(this.mobileData)
        if(this.$route.query.page) {

            this.curpage =this.$route.query.page
            this.curData = this.tempData.slice((this.curpage - 1) * 8, this.curpage * 8)
        }
        this.total = this.tempData.length;
        console.log(this.total)
        this.tag = true;
        if (this.total > 0) {
          this.pageshow = true;
        }
      },
      getCurData(data) {
        this.curData = data.filter((value, index) => {
          return index < this.pageSize * this.curpage && index >= this.pageSize * (this.curpage - 1)
        })
      },
      loadingData() {
        this.mobileData = this.mobileData.concat(this.tempData.slice((this.curpage - 1) * 8, this.curpage * 8))
      },
      //关键字搜索
      searchBykeword() {
        this.tempData = this.allData.filter((item, i) => {
          return item.name.indexOf(this.keyword) > -1
        })
        this.mobileData = this.tempData.slice((this.curpage - 1) * 8, this.curpage * 8)
        this.total = this.tempData.length;
        this.curData = this.tempData.slice((this.curpage - 1) * 8, this.curpage * 8)
      },
      //分类选个
      classify(type, param) {
        param = param || 'type';
        this.curpage = 1;
        this.mobileData = [];

        if (type == 'all') {
          // this.loadingData()
          this.$router.push({
              path: '/antiques'
              
            })
        } else {
          this.tempData = this.mobileData = this.allData.filter((item, i) => {
            return item[param] == type
          })
          this.total = this.tempData.length;
          console.log(this.total)
          this.curData = this.tempData.slice((this.curpage - 1) * 8, this.curpage * 8);
          if (param == 'type') {
            this.$router.push({
              path: '/antiques',
              query: {
                type: type
              }
            })
          } else {
            this.$router.push({
              path: '/antiques',
              query: {
                nature: type
              }
            })
          }


        }


      },
      pageChange(num) {
        this.curpage = num;
        
        this.$router.push({
              path: '/antiques',
              query: {
                type: this.$route.query.type,
                nature: this.$route.query.nature,
                keyword:this.$route.query.keyword,
                page:num
              }
            })
      },
      scrollBottom() {
        var that = this;
        if ((document.body.clientHeight + that.$refs.scrollContainer.scrollTop) >= that.$refs.scrollContainer
          .scrollHeight) {
          console.log("已经到最底部");
          that.curpage++;
          if (that.curpage > (this.total / this.pageSize)) {
            console.log("没有更多了！");
            this.nomore = true;
          }


        }
      },
      backTop () {
        console.log("回到顶部")
        this.$refs.scrollContainer.scrollTop = 0;

  },
 
  // 为了计算距离顶部的高度，当高度大于60显示回顶部图标，小于60则隐藏
  


    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
      this.getData();





    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        var that = this;
        that.getData();
      window.addEventListener('touchmove', function () {
        that.scrollBottom();
      });
     

    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {
     

    }, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
  }
</script>
<style lang='less' scoped>
  @len: 13;

  .loop(@count)when(@count > -1) {
    .icon@{count} {
      background:#d4050f url("../../assets/images/icon@{count}.png")2.4vw center/1.82vw no-repeat;
    }

    .loop((@count - 1));
  }

  //@import url(); 引入公共css类
  .antiques {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    .inner {
      width:100%;
      height:100%;
    }
    /* padding-top:10vh; */
    .left-nav {
      width: 18.75vw;
      height: 100%;
      float: left;
      background: #e60012;
      padding-top: 5vw;

      .search {
        height: 2.9vw;
        display: flex;
        justify-content: center;

        input {
          width: 11.97vw;
          height: 2.08vw;
          font-size: 1vw;
          padding-left: 1em;
          background: #fde6e8;
          margin-right: 5px;

        }

        button {
          width: 5.2vw;
          height: 2.08vw;
          background: #fde6e8 url(../../assets/images/sw.png)0.5vw center / 1.2vw no-repeat;
          color: #e60012;
          font-size: 1vw;
          padding-left: 2vw;
          text-align: start;
        }
      }

      .navs {
        .nav {
          span {
            display: block;
            width: 100%;
            border-top: 1px solid #fff;
            height: 2.65vw;
            line-height: 2.65vw;
            color: #fff;
            background: #d4050f;
            cursor: pointer;
          }
        }

        .nav1 {
          span {
            background: #d4050f url(../../assets/images/qw.png)2.4vw center/1.82vw no-repeat;
          }

          ul {
            li {
              color: #fff;
              display: block;
              width: 100%;
              height: 1.92vw;
              line-height: 1.92vw;
              cursor: pointer;

              &:hover {
                color: #efe8cb;
              }
            }
          }
        }

        .nav2 {
          span {
            &:hover {
              color: #efe8cb;
            }
            &.icon13 {
              border-bottom:1px solid #fff;
            }
          }

          .loop(13)
        }
      }
    }

    .list-container {
      width: 81.25vw;
      margin-top: 10vw;
      padding-right: 5vw;
      float: right;

      .list {
        .item {
          position:relative;
          display: inline-block;
          width: 18vw;


          box-shadow: 0 0 10px #696363;
          margin: 1vw 0.3vw;

          .imgC {
            width: 100%;
            height: 12.1875vw;
            img {
              object-fit: cover;
              width:100%;
              height:100%;
              // max-width:100%;
              // max-height:100%;
            }
          }

          .text {

            width: 100%;
            height: 2.6vw;
            line-height: 2.6vw;
            background: #e60012;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            color: #fff;
            padding: 0 1em;

            span {

              color: #fff;
              cursor: default;
            }
          }
          .d3 {
            position:absolute;
            width:30px;
            top:10px;
            right:10px;
          }
        }

        .nothing {
          color: #e60012;
          font-size: 2vw;
          height: calc(100vh - 10vw);
          display: flex;
          justify-content: center;
          text-align: center;
          align-items: center;

        }
      }
    }

  }

  //移动样式
  .mlayout {
    .minner {
      .top-search {
        width: 100%;

        .keysearch {
          display: flex;
          justify-content: center;

          input {
            width: 44.2vw;
            height: 8vw;
            border: 1px solid #e60012;
            padding-left: 1em;
          }

          button {
            width: 13.3vw;
            height: 8vw;
            background: url(../../assets/images/mobile/search.png)center /100% no-repeat;
            margin-right: 4.2vw;
          }

          span {
            display: block;
            width: 28vw;
          }
        }

        .navs {
          width: 100%;

          height: 7vw;
          border-bottom: 1px solid #bfbfbf;
          margin: 5vw auto 4vw;

          ul {
            white-space: nowrap;

            li {
              position: relative;
              font-size: 4vw;
              color: #515151;
              padding: 0 2.9vw;
              display: inline-block;
              line-height: 7vw;

              .pulldown {
                position: absolute;
                top: 8vw;
                left: -2.9vw;
                background: #fff;
                width: calc(100% + 5.8vw);
                z-index: 2;

                span {
                  display: block;
                  width: 80%;
                  margin: 0 auto;
                  border-bottom: 1px solid #e60012;

                  &:last-child {
                    border-bottom: none;
                  }
                }
              }
            }
          }
        }

      }

      .list {
        margin: 0 5.3vw;
        overflow: hidden;

        .item {
          position: relative;
          float: left;
          width: 42.67vw;
          background: #e9e9ea;
          margin-bottom: 4vw;
          overflow: hidden;

          &:nth-child(2n) {
            margin-left: 4.06vw;
          }

          .imgC {
            height: 28vw;
          }

          .text {
            background: #e60012;
            color: #fff;
            font-size: 3.2vw;
            height: 6.67vw;
            line-height: 6.67vw;
          }

          .d3 {
            position: absolute;
            width: 4vw;
            top: 2vw;
            right: 2vw;

          }
        }
      }

      .nomore {
        text-align: center;
        margin: 2vw auto 30vw;
      }

      .up-top {
        position: fixed;
        width: 7.2vw;
        right: 3vw;
        bottom: 30vw;
        z-index: 22;
      }
    }
  }

  .swiper-container {
    margin: 0 5.3vw;
    overflow: hidden;
  }

  .swiper-container-horizontal {
    height: 7vw;

  }

  .antiqueSlide {
    width: auto;
    white-space: nowrap;
  }

  .swiper-container-free-mode>.swiper-wrapper {
    width: auto;
    white-space: nowrap;
  }
</style>


// WEBPACK FOOTER //
// src/pages/antiques/index.vue